import { usePasteCode } from "@libs/identity-ui/paste";
import LPressable from "@components/LPressable";
import { Text } from "react-native";
import type { PasteCodeProps } from "./PasteCode";

/** App-web: "Paste code" where the browser lets a page read the clipboard
 *  on a tap, nothing where it does not (as Link in Bio's). */
export function PasteCode({
  onCode,
  disabled = false,
  color,
  fontFamily,
  testID,
  sentryEventName,
}: PasteCodeProps) {
  const paste = usePasteCode(onCode);
  if (!paste) return null;
  return (
    <LPressable
      accessibilityLabel="Paste code"
      accessibilityRole="button"
      disabled={disabled}
      hitSlop={8}
      onPointerDown={(event) => event.preventDefault()}
      onPress={paste}
      sentryEventName={sentryEventName}
      shouldDismissKeyboard={false}
      style={{ opacity: disabled ? 0.5 : 1 }}
      testID={testID}
    >
      <Text
        style={{
          color,
          fontFamily,
          fontSize: 13,
          fontWeight: fontFamily ? undefined : "600",
        }}
      >
        Paste code
      </Text>
    </LPressable>
  );
}
